import React from "react";
import "../Css/WhyChoose.css";
import chooseImg from "../assets/why.jpg";

const WhyChoose = () => {
  const data = [
    {
      no: "01",
      title: "Experienced & Verified Maids",
      desc: "All our maids are trained, skilled, and background verified, ensuring safe and reliable help for your home.",
      color: "#1e9bc7",
    },
    {
      no: "02",
      title: "Specialized Household Services",
      desc: "Our maids handle house cleaning, cooking, laundry, childcare, elder care, and more.",
      color: "#ff5c5c",
    },
    {
      no: "03",
      title: "24/7 Support",
      desc: "Our team is available round the clock to assist and support you anytime.",
      color: "#8dc63f",
    },
  ];

  return (
    <section className="choose">
      <div className="choose-wrapper">

        {/* LEFT */}
        <div className="choose-left">
          <span className="choose-label">WHY CHOOSE US</span>

          <h2 className="choose-title">
            Why Choose <span>Tanya Maid Service</span> ?
          </h2>

          {data.map((item, i) => (
            <div className="choose-card" key={i}>
              <div
                className="choose-badge"
                style={{ background: item.color }}
              >
                ✓
                <span>{item.no}</span>
              </div>

              <div className="choose-content">
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* RIGHT IMAGE */}
        <div className="choose-right">
          <img src={chooseImg} alt="maid service" />
        </div>

      </div>
    </section>
  );
};

export default WhyChoose;
